module.exports = __webpack_public_path__ + "img/inventory.b612f593.svg";